import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../lib/utils.js';

const badgeVariants = cva(
  'inline-flex items-center rounded-full px-3 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground shadow',
        secondary: 'bg-secondary text-secondary-foreground',
        destructive: '',
        outline: 'border text-foreground',
        success: '',
        warning: '',
        info: '',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

const pastelStyles: Record<string, React.CSSProperties> = {
  success: { backgroundColor: 'hsl(142, 76%, 90%)', color: 'hsl(142, 71%, 25%)' },
  warning: { backgroundColor: 'hsl(45, 100%, 88%)', color: 'hsl(32, 81%, 25%)' },
  info: { backgroundColor: 'hsl(217, 95%, 90%)', color: 'hsl(217, 91%, 30%)' },
  destructive: { backgroundColor: 'hsl(0, 86%, 90%)', color: 'hsl(0, 72%, 30%)' },
};

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, style, ...props }: BadgeProps) {
  const inlineStyle =
    variant && variant in pastelStyles ? { ...pastelStyles[variant], ...style } : style;
  return (
    <div className={cn(badgeVariants({ variant }), className)} style={inlineStyle} {...props} />
  );
}

export { Badge, badgeVariants };
